export class PriceCurrency {
  indexCurrency: number;
  code: string;

  constructor(
    indexCurrency: number,
    code: string,
  ) {
    this.indexCurrency = indexCurrency;
    this.code = code;
  }

  static fromRaw(raw: any): PriceCurrency {
    return new PriceCurrency(
      raw.indexCurrency,
      String(raw.code),
    );
  }

  clone(): PriceCurrency {
    return new PriceCurrency(
      this.indexCurrency,
      this.code,
    );
  }

  toPayload(): any {
    return {
      indexCurrency: this.indexCurrency,
      code: this.code,
    };
  }
}
